<template>
  <div class="modal fade" id="terminationModal" tabindex="-1" aria-labelledby="terminationModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content" v-if="!loading">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="terminationModalLabel">
            Расторжение
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <template v-if="!loading">
          <div class="modal-body p-5" v-if="global">
            <template v-if="!terminationSum">
              <div class="mb-3" v-if="person">
                <div v-if="step === 1 || step === 2" class="text-gray-500 fw-semibold fs-6 mb-3 text-center">Код был отправлен на номер <b>{{ this.sendPhone }}</b></div>
                <div class="w-275px m-auto">
                  <input-mask-field
                      v-model="code"
                      id="form.code"
                      name="form_code"
                      :disabled="step !== 1"
                      :required="true"
                      :mb="5"
                      placeholder="Код"
                      mask="####"
                      type="text"
                  />
                  <button v-if="step === 0" class="btn btn-primary btn-sm btn-block" @click="sendCode">
                    <span class="indicator-label">Отправить код</span>
                  </button>
                  <button v-if="step === 1" class="btn btn-warning btn-sm btn-block" :disabled="this.timer !== 0" @click="sendCode">
                    <span class="indicator-label">Повторно отправить код <span v-if="this.timer > 0"> через {{ this.timer }} сек.</span></span>
                  </button>
                  <div v-if="step === 2">
                    <select-field-from-model
                        v-if="this.signatories"
                        v-model="this.signatory_id"
                        id="policy.signatory"
                        name="policy.signatory"
                        :options="this.signatories"
                        :required="true"
                        placeholder="Подписант"
                        mb="5"
                    />
                    <button class="btn btn-primary btn-sm btn-block" @click="termination">
                      <span class="indicator-label">Подтвердить код</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="mb-3" v-else>
                <div class="w-275px m-auto">
                  <button v-if="!person" class="btn btn-primary btn-sm btn-block" @click="termination">
                    <span class="indicator-label">Отправить "Расторжение"</span>
                  </button>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="alert alert-primary d-flex align-items-center p-5 mb-10">
                <i class="ki-duotone ki-shield-tick fs-2hx text-primary me-4">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <div class="d-flex flex-column">
                  <h4 class="mb-1 text-primary">Процесс по <b v-html="this.global"></b> успешно завершен</h4>
                </div>
                <div v-if="terminationSum">
                  Сумма возврата: <small>{{terminationSum.toLocaleString('ru-RU')}}</small>
                </div>
              </div>
            </template>
          </div>
          <div class="modal-body p-5" v-else>
            <div class="text-center">
              Параметр <b class="text-danger">Global</b> не указано!
            </div>
          </div>
        </template>
        <div class="modal-footer p-2 justify-content-center">
          <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Отменить</button>
        </div>
      </div>
      <div class="modal-content" v-else>
        <loader-full :text="loadingText" style="min-height: 323px"/>
      </div>
    </div>
  </div>
</template>
<script>
import SelectFieldFromModel from "@/components/Fields/SelectFieldFromModel.vue";
import InputMaskField       from '@/components/Fields/InputMaskField'
import LoaderFull           from '@/components/Main/LoaderFull'
import axios                from 'axios'

export default {
  name: 'TerminationModal',
  components: {SelectFieldFromModel, LoaderFull, InputMaskField},
  props: {
    signatories: null,
    resident: null,
    person:   null,
    global:   null,
    hash:     null,
    ip:       null
  },
  data() {
    return {
      terminationSum: null,
      signatory_id:   false,
      loadingText:    '',
      sendPhone:      '',
      interval:       null,
      loading:        false,
      success:        false,
      timer:          0,
      code:           '',
      step:           0,
    }
  },
  methods: {
    countDownTimer () {
      this.interval = setInterval(() => {
        if (this.timer === 0) {
          clearInterval(this.interval)
          this.timer = 0
        } else {
          this.timer = this.timer - 1
        }
      }, 1000)
    },
    sendCode() {
      this.loading = true
      this.loadingText = 'Отправляем код'
      axios.post('/api/contracts/process-otp', { hash:this.hash, type:3 })
          .then(res => {
            if (res.data.result) {
              this.timer = 90
              this.countDownTimer()
              if (res.data.sendPhone) this.sendPhone = res.data.sendPhone
              this.step = 1
            } else
              this.$notifyError(res.data)
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => {
            this.loading = false
            this.loadingText = ''
          })
    },
    termination() {
      this.loading = true
      this.loadingText = 'Оформление "Расторжения"'
      const headers = {
        signatoryId: this.signatory_id,
        isRescind:   false,
        global:      this.global,
        person:      this.person,
        hash:        this.hash,
        code:        this.code,
        type:        3,
        ip:          this.ip
      }
      axios.post('/api/contracts/rescind', headers)
          .then(res  => {
            if (res.data.result) {
              this.$emit('reload', true)
              this.terminationSum = res.data.message
            } else {
              this.$notifyError(res.data)
              this.step = 1
            }
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => {
            this.loading      = false
            this.loadingText  = ''
          })
    },
    modalHidden() {
      const myModalEl = document.getElementById('operatorErrorModal');
      const modal     = bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
    },
  },
  watch: {
    code: {
      deep: true,
      handler: function(newValue) {
        this.step = newValue.length === 4 ? 2 : 1
      }
    },
  }
}
</script>
<style scoped>

</style>